import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { InputField } from "veronica-ui-component/dist/component/core";

export const ExciseCashCashReceiptNoAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <InputField
                        label='Excise Cash No.'
                        width='150px'
                        type="text"
                        maxLength={300}
                        value={chargeBatchUpdate.exciseCashNo || ''}
                        onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'exciseCashNo', chargeBatchUpdate, 'chargeBatchUpdate')}
                    />
                </div>
                <div className='im-flex-row-item'>
                    <InputField
                        label='Cash Receipt No.'
                        width='150px'
                        type="text"
                        maxLength={10}
                        value={chargeBatchUpdate.cashReceiptNo || ''}
                        onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'cashReceiptNo', chargeBatchUpdate, 'chargeBatchUpdate')}
                    />
                </div>
            </div>
        </>
    )
}